import { Navigate } from 'react-router-dom';
import FeatureFlag from '../featureFlag/FeatureFlag';
import Logout from './Logout';
import { BBLogin } from './bbOauth/BBLogin';
import HwbLogin from './hwbAuth/HwbLogin';


const authRoutes = [
  {
    path: 'bblogin',
    element: <BBLogin />
  },
  {
    path: `hwblogin`,
    element: <FeatureFlag fallback={<Navigate to={'/'}/>} flag={['hwb']}><HwbLogin /></FeatureFlag>
  },
  {
    path: 'logout',
    element: <Logout />
  }
];

export default authRoutes;
